const isLocalDevelopment = ['localhost', '127.0.0.1'].includes(window.location.hostname);
const configuredApiBase = process.env.API_BASE_URL
  || (isLocalDevelopment ? `http://${window.location.hostname}:8484` : 'https://moe-pi.ddns.net/babyplanner-api');

export const API_BASE_URL = configuredApiBase.replace(/\/$/, '');
export const PUBLIC_API_TOKEN = process.env.PUBLIC_API_TOKEN || '';

export function publicApiHeaders(extraHeaders = {}) {
  return {
    Authorization: `Bearer ${PUBLIC_API_TOKEN}`,
    ...extraHeaders
  };
}
